import { niTrackEvent, trackShowMore } from '@xsite-ui/common.event-tracker';

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function initShowMoreScript() {
  var chartElement = document.querySelector('.chart-wrapper');

  if (!chartElement) {
    return;
  }

  var showMoreLessButtons = document.querySelectorAll('[data-hook="show-more"]');

  var _iterator = _createForOfIteratorHelper(showMoreLessButtons),
      _step;

  try {
    var _loop = function _loop() {
      var _buttonChartElement$d;

      var showMoreBtn = _step.value;
      var buttonChartElement = showMoreBtn.closest('.chart-wrapper');
      var compIID = (_buttonChartElement$d = buttonChartElement === null || buttonChartElement === void 0 ? void 0 : buttonChartElement.dataset.compIid) !== null && _buttonChartElement$d !== void 0 ? _buttonChartElement$d : '';
      var totalChartRows = Number(buttonChartElement === null || buttonChartElement === void 0 ? void 0 : buttonChartElement.dataset.totalProducts);
      var partialVisibleChartRows = Number(buttonChartElement === null || buttonChartElement === void 0 ? void 0 : buttonChartElement.dataset.visibleProducts);
      showMoreBtn.addEventListener('click', function showBtnClicked(event) {
        var showMoreButton = event.target;

        if (showMoreButton instanceof Element) {
          var showMore = showMoreButton === null || showMoreButton === void 0 ? void 0 : showMoreButton.closest('[data-state]');

          if (showMore) {
            var _showMore$dataset$sta;

            var currentState = (_showMore$dataset$sta = showMore.dataset.state) !== null && _showMore$dataset$sta !== void 0 ? _showMore$dataset$sta : '';

            if (currentState === 'more') {
              showMore.dataset.state = 'less';
              showMore.classList.add('open');
            } else {
              showMore.dataset.state = 'more';
              showMore.classList.remove('open');
            }

            niTrackEvent({
              category: currentState,
              action: "User clicked on ".concat(currentState),
              optLabel: showMore.dataset.siteId,
              optValue: 0,
              optNonInteraction: false
            });
            trackShowMore({
              comp_iid: compIID,
              action: "User clicked on show ".concat(currentState, " button"),
              product_list_size: currentState === 'more' ? totalChartRows : partialVisibleChartRows
            });
          }
        }
      });
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

export { initShowMoreScript };
